'use client'
import { useState, useEffect } from 'react'
import LargePropertyCard from '@components/LargePropertyCard'
import LoadingCard from '@components/LoadingCard'
// import SaleFilter from '@components/Search/SaleFilter'
import DistrictFilterTab from '@components/Search/DistrictFilterTab'
import SearchMap from '@components/SearchMap'
import MobileSearchMap from '@components/MobileSearchMap'
import MobileMapPropertyCard from '@components/MobileMapPropertyCard'
import { getDistrict } from '@services/getDistrict'
import { saleTypes } from '@constants/saleTypes'
import Image from 'next/image'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';


const DistrictPage = ({ params, searchParams, dictionary, lang }) => {

    const [search, setSearch] = useState(searchParams)
    const [isLoading, setIsLoading] = useState(false)
    const [page, setPage] = useState(1);
    const [allPages, setAllPages] = useState(1);
    const [properties, setProperties] = useState([]);
    const [district, setDistrict] = useState([]);
    const [propertyCount, setPropertyCount] = useState(0);
    const [showMap, setShowMap] = useState(false)
    const [coordinates, setCoordinates] = useState([])
    const [hoveredProperty, setHoveredProperty] = useState(null)
    const [activeProperty, setActiveProperty] = useState({})
    const [activePropertyLat, setActivePropertyLat] = useState(13.732772)
    const [activePropertyLng, setActivePropertyLng] = useState(100.5801953)
    const [btsList, setBtsList] = useState([])

    const handleMouseEnter = (propertyId) => {
        // console.log(e)
        // console.log('hover ' + propertyId)
        setHoveredProperty(propertyId)
    };
    const handleMouseLeave = () => {
        // console.log('hover end')
        setHoveredProperty(null)
    };

    const handleSlideChange = (swiper) => {
        // Emit your event or perform actions when the active slide changes
        const activeSlideIndex = swiper.activeIndex;
        // console.log(`Active slide index: ${activeSlideIndex}`);
        let activePropertyId = swiper.slides[activeSlideIndex].id
        let activePropertyLat = swiper.slides[activeSlideIndex].dataset.latitude
        let activePropertyLng = swiper.slides[activeSlideIndex].dataset.longitude
        setActiveProperty(activePropertyId)
        setActivePropertyLat(activePropertyLat)
        setActivePropertyLng(activePropertyLng)

        // Emit an event or perform actions here
    };

    const getData = async (pageNumber) => {
        setIsLoading(true)

        const result = await getDistrict(
            params.slug, 
            {
                saleType: searchParams.saleType || saleTypes[lang][0].value,
                bts: searchParams.bts || '',
                project: searchParams.project || '',
                category: searchParams.category || '',
                minBedrooms: searchParams.minBedrooms || '',
                maxBedrooms: searchParams.maxBedrooms || '',
                room: searchParams.room || '',
                currency: searchParams.currency || 'thb',
                minprice: searchParams.minprice || '',
                maxprice: searchParams.maxprice || '',
                petfriendly: searchParams.petfriendly || '',
                map: searchParams.map || false,
                sort: searchParams.sort || 'datedesc',
                // limit: searchParams.limit || 10,
                page: pageNumber
            },
            lang
        )

        // setProperties(result.properties)
        if (pageNumber > 1) {
            setProperties((prev) => [...prev, ...result.properties])
        } else {
            setProperties(result.properties)
        }
        setDistrict(result.district)
        setAllPages(result.pages)
        setPropertyCount(result.count)
        setCoordinates(result.coordinates)
        setBtsList(result.btsList)
        if (result.properties.length > 0 && page == 1) {
            setActiveProperty(result.properties[0].id)
            setActivePropertyLat(Number(result.properties[0].latitude))
            setActivePropertyLng(Number(result.properties[0].longitude))
        }

        setIsLoading(false)
    }

    useEffect(() => {
        setPage(1)
        setProperties([])
        setShowMap(searchParams.map)

        getData(1)
    }, [searchParams])

    useEffect(() => {
        getData(page)
    }, [page])

    return (
        <div>
            {showMap ? null : (
                <div className='w-full sm:h-[600px] h-[250px] z-0 mx-auto relative'>
                    {/* <div className='absolute z-10 bg-maincolor opacity-20 top-0 bottom-0 left-0 right-0'></div> */}
                    <div className='absolute z-10 left-0 top-0 bottom-0 right-0 bg-gradient-to-r from-black/80 to-slate-500/0'></div>

                    <div>
                        <Image
                            src={district?.coverImage}
                            // src={`/images/bkkdistrict.jpg`}
                            alt={district?.subdistrict}
                            // width={700}
                            // height={250}
                            fill={"true"}
                            style={{
                                objectFit: 'cover'
                            }}
                        />
                        <div className='absolute sm:w-full 2xl:w-10/12 mx-auto top-2 left-2 right-2 z-10 p-2 flex'>
                            <div className='mt-[90px] bg-light bg-opacity-70 rounded-sm p-2'>
                                <h1 className='text-maincolor font-bold rounded-sm'>{district.subdistrict} {dictionary.filter.properties}</h1>
                                <p className='text-maincolor text-md'>{district.location}</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* {saleTypes.length > 1 &&
                    <div className='absolute sm:w-full 2xl:w-8/12 mx-auto bottom-2 left-2 right-2 z-10'>
                        <SaleFilter title="saleType" options={saleTypes} searchParams={searchParams} />
                    </div>
                } */}
            <DistrictFilterTab searchParams={searchParams} dictionary={dictionary} lang={lang} />
            <div className='sm:w-full 2xl:w-10/12 mx-auto'>
                {/* {showMap ? null : (
                    <h2 className='text-maincolor font-bold text-xl my-2 px-4'>{propertyCount} {dictionary.districts.results}{dictionary.districts.for}{properties[0]?.saleType ? properties[0].saleType : saleTypes[lang][0].title}{dictionary.districts.in}{district.subdistrict}</h2>
                )} */}
                <div className='w-full flex sm:flex-row flex-col flex-wrap justify-start mx-auto md:px-3 px-0'>

                    {showMap ? (
                        <div className='w-full relative flex flex-row mx-auto'>
                            <div className='md:flex hidden md:h-[80vh] h-full min-w-[320px] pt-2 overflow-hidden overflow-y-scroll rounded-l-md border-forth border-[1px] border-solid flex-col items-center scrollable' >
                                {properties.map((property, index) => (
                                    <div
                                        key={property.id}
                                        id={property.id}
                                        // className='m-2'
                                        onMouseEnter={() => (handleMouseEnter(property.id))}
                                        onMouseLeave={handleMouseLeave}
                                        className='mb-2'
                                    >
                                        <LargePropertyCard
                                            dictionary={dictionary.card}
                                            lang={lang}
                                            property={property}
                                            isLast={index === properties.length - 1}
                                            // imageWidth={imageWidth}
                                            newLimit={() => { page < allPages ? setPage(page + 1) : setPage(page) }}
                                        />
                                    </div>
                                ))}
                                {isLoading && (  
                                    <div className='m-2'>
                                        <LoadingCard />
                                    </div>  
                                )}
                                {isLoading && (  
                                    <div className='m-2'>
                                        <LoadingCard />
                                    </div>  
                                )}
                                {isLoading && (  
                                    <div className='m-2'>
                                        <LoadingCard />
                                    </div>  
                                )}
                                {isLoading && (  
                                    <div className='m-2'>
                                        <LoadingCard />
                                    </div>  
                                )}
                                {isLoading && (  
                                    <div className='m-2'>
                                        <LoadingCard />
                                    </div>  
                                )}
                            </div>
                            <div className='md:hidden block absolute bottom-0 left-0 right-0 z-[52]'>
                                {/* {properties && ( */}
                                <div className='sm:hidden block'>
                                    <Swiper
                                        // spaceBetween={10}
                                        slidesPerView={1}
                                        // onSlideChange={() => console.log('slide change')}
                                        onSlideChange={handleSlideChange}
                                    // onSwiper={(swiper) => console.log(swiper)}
                                    >
                                        {properties.map((property, index) => (
                                            <SwiperSlide
                                                key={property.id}
                                                id={property.id}
                                                data-latitude={Number(property.latitude)}
                                                data-longitude={Number(property.longitude)}
                                            >
                                                <MobileMapPropertyCard
                                                    dictionary={dictionary.card}
                                                    lang={lang}
                                                    property={property}
                                                    isLast={index === properties.length - 1}
                                                    // imageWidth={imageWidth}
                                                    newLimit={() => { page < allPages ? setPage(page + 1) : setPage(page) }}
                                                />
                                            </SwiperSlide>
                                        ))}
                                        {isLoading && (  
                                            <div className='m-2'>
                                                <LoadingCard />
                                            </div>  
                                        )}
                                        {isLoading && (  
                                            <div className='m-2'>
                                                <LoadingCard />
                                            </div>  
                                        )}
                                        {isLoading && (  
                                            <div className='m-2'>
                                                <LoadingCard />
                                            </div>  
                                        )}
                                        {isLoading && (  
                                            <div className='m-2'>
                                                <LoadingCard />
                                            </div>  
                                        )}
                                        {isLoading && (  
                                            <div className='m-2'>
                                                <LoadingCard />
                                            </div>  
                                        )}
                                    </Swiper>
                                </div>
                                {/* )} */}
                            </div>
                            <div className='md:block hidden md:h-[80vh] h-full md:relative absolute w-full border-forth border-[1px] border-solid rounded-r-md overflow-hidden'>
                                <SearchMap coordinates={coordinates} hoveredProperty={hoveredProperty} latitude={district.latitude} longitude={district.longitude} geoJSON={district.geoJSON} dictionary={dictionary.card} lang={lang} />
                            </div>
                            <div className='md:hidden block w-full h-full z-[51] overflow-hidden'>
                                <MobileSearchMap coordinates={coordinates} hoveredProperty={activeProperty} zoomControl={false} latitude={activePropertyLat} longitude={activePropertyLng} geoJSON={district.geoJSON} dictionary={dictionary.card} lang={lang} />
                            </div>
                        </div>
                    ) : (
                        <div className='flex flex-row flex-wrap min-h-[25vh]'>
                            {properties.map((property, index) => (
                                <div
                                    key={property.id}
                                    className='m-2'
                                >
                                    <LargePropertyCard className='m-3'
                                        dictionary={dictionary.card}
                                        lang={lang}
                                        property={property}
                                        isLast={index === properties.length - 1}
                                        // imageWidth={imageWidth}
                                        newLimit={() => { page < allPages ? setPage(page + 1) : setPage(page) }}
                                    />
                                </div>
                            ))}
                            {isLoading && (  
                                <div className='m-2'>
                                    <LoadingCard />
                                </div>  
                            )}
                            {isLoading && (  
                                <div className='m-2'>
                                    <LoadingCard />
                                </div>  
                            )}
                            {isLoading && (  
                                <div className='m-2'>
                                    <LoadingCard />
                                </div>  
                            )}
                            {isLoading && (  
                                <div className='m-2'>
                                    <LoadingCard />
                                </div>  
                            )}
                            {isLoading && (  
                                <div className='m-2'>
                                    <LoadingCard />
                                </div>  
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default DistrictPage